function initPopups(scope) {
  var popups = (scope || document).querySelectorAll('[data-popup]');

  popups.forEach(function (popup) {
    if (popup.dataset.popupInitialized === 'true') return;

    popup.dataset.popupInitialized = 'true';

    var closeButtons = popup.querySelectorAll('[data-popup-close]');

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        popup.classList.add('is-hidden');
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initPopups(document);
});

document.addEventListener('shopify:section:load', function (event) {
  initPopups(event.target);
});
